var VALUE = 'value';
var KEY = 'key';
export default {
  KEY: KEY,
  VALUE: VALUE
};